import LegalPage from './LegalPage';
import { cookieBlocks } from './legalBlocks';

export default function CookiesPage() {
  return <LegalPage blocks={cookieBlocks} />;
}
